import React, { useState, useEffect } from "react";
import "./CSS/LandingPage.css";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import logo from "../assets/icone.png";
import ServiceFeeModal from "./Login/ServiceFeeModal";

import image_1 from "../assets/ACL/1.png";
import image_2 from "../assets/ACL/2.png";
import image_3 from "../assets/ACL/3.png";
import image_4 from "../assets/ACL/4.png";

const LandingPage = () => {
  const navigate = useNavigate();

  const [cookies, setCookes] = useState("");
  const [showEmployerPassword, setShowEmployerPassword] = useState(false);
  const [employerPassword, setEmployerPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showServiceFee, setShowServiceFee] = useState(false);

  const [heroScrolled, setHeroScrolled] = useState(false);

  const handleNavigation = (destination) => {
    const username = Cookies.get("userID");
    const agentname = Cookies.get("agent_name");

    if (destination === "my_account" && username == null) {
      navigate("/login");
      return;
    }

    if (destination === "agent" && agentname == null) {
      navigate("/Agent_login");
      return;
    }

    navigate(`/${destination}`);
  };

  const handleAboutClick = () => {
    const aboutSection = document.getElementById("about");

    if (aboutSection) {
      aboutSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const handleContactsClick = () => {
    const contactsSection = document.getElementById("contacts");

    if (contactsSection) {
      contactsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    const username = Cookies.get("userID");
    setCookes(username || "");
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      if (scrollPosition > 40) {
        setHeroScrolled(true);
      } else {
        setHeroScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleEmployerClick = () => {
    setEmployerPassword("");
    setPasswordError("");
    setShowEmployerPassword(true);
  };

  const closeEmployerPassword = () => {
    setShowEmployerPassword(false);
    setEmployerPassword("");
    setPasswordError("");
  };

  const handleEmployerLogin = (e) => {
    e.preventDefault();

    if (employerPassword === "369@LLLE") {
      setPasswordError("");
      setShowEmployerPassword(false);
      setEmployerPassword("");
      navigate("/employer");
    } else {
      setPasswordError(
        "Wrong password. Please enter the correct employer password."
      );
    }
  };

  return (
    <div
      className={`landing-page ${
        heroScrolled ? "landing-page-scrolled" : "landing-page-initial"
      }`}
    >
      <div className="landing-background"></div>

      <div className="landing-background-overlay"></div>

      <nav className="landing-nav">
        <div
          className="landing-logo landing-nav-clickable"
          onClick={() => navigate("/")}
        >
          <img
            src={logo}
            alt="Advenware Career Link"
            className="landing-logo-image"
          />

          <div className="landing-logo-text">
            <strong>Advenware</strong>
            <span>Career Link</span>
          </div>
        </div>

        <div className="landing-nav-center">
          <button
            className="landing-nav-link"
            onClick={() => navigate("/")}
          >
            Home
          </button>

          <button
            className="landing-nav-link"
            onClick={() => handleNavigation("opportunities")}
          >
            Opportunities
          </button>

          <button
            className="landing-nav-link"
            onClick={() => handleNavigation("my_account")}
          >
            For Candidates
          </button>

          <button
            className="landing-nav-link"
            onClick={() => handleNavigation("About")}
          >
            About Us
          </button>

          <button
            className="landing-nav-link"
            onClick={handleContactsClick}
          >
            Contacts
          </button>
        </div>

        <div className="landing-nav-right">
          <span className="nav-status">
            <i></i>
            Connecting careers
          </span>

          {cookies === "" ? (
            <button
              className="nav-login"
              onClick={() => handleNavigation("login")}
            >
              Log in
            </button>
          ) : (
            <button
              className="nav-login"
              onClick={() => {
                Cookies.remove("userID");
                setCookes("");
              }}
            >
              Sign out
            </button>
          )}
        </div>
      </nav>

      <div className="landing-orb orb-one"></div>
      <div className="landing-orb orb-two"></div>
      <div className="landing-orb orb-three"></div>
      <div className="landing-lines"></div>

      <main className="landing-main">

        <div className="landing-top-label">
          <span className="label-line"></span>

          <span>
            STUDENTS • EMPLOYERS • FIELD AGENTS
          </span>

          <span className="label-line"></span>
        </div>

        <div className="landing-hero">

          <div className="hero-badge">
            <span></span>
            CAREER & TALENT ADVANCEMENT NETWORK
          </div>

          <h1>
            What we are about
            <br />
            <span>
              BUILDING CAREERS. CONNECTING OPPORTUNITIES. TRANSFORMING FUTURES.
            </span>
          </h1>

          <p>
            Advenware Career Link connects individuals with opportunities,
            professional development and organisations looking for emerging
            and skilled talent.
          </p>

          <div className="hero-statistics">

            <div className="hero-stat">
              <strong>17,000+</strong>
              <span>STUDENTS & GRADUATES PLACED</span>
            </div>

            <div className="hero-stat">
              <strong>8,500+</strong>
              <span>ATTACHMENT PLACEMENTS</span>
            </div>

            <div className="hero-stat">
              <strong>4,200+</strong>
              <span>INTERNSHIP PLACEMENTS</span>
            </div>

            <div className="hero-stat">
              <strong>2,300+</strong>
              <span>JOB PLACEMENTS</span>
            </div>

            <div className="hero-stat">
              <strong>250+</strong>
              <span>PARTNER ORGANISATIONS</span>
            </div>

          </div>

          <div className="hero-actions">
            <button
              className="hero-primary-button"
              onClick={() => handleNavigation("opportunities")}
            >
              Explore opportunities
              <span>→</span>
            </button>
          </div>

        </div>

        <section
          id="about"
          className="acl-about-section"
        >
          <div className="acl-about-header">
            <span>ADVENWARE CAREER LINK</span>

            <h2>
              Where Potential Becomes Possibility.
            </h2>

            <p>
              Advenware Career Link (ACL) is a dynamic talent and career
              advancement network engineered to bridge the distance between
              ambition and achievement.
            </p>
          </div>

          <div className="acl-about-content">
            <p>
              From attachment and internship placements to job opportunities,
              professional skills training, career guidance, CV development,
              interview preparation, and talent development, we create
              pathways that equip individuals with the experience, competence,
              and confidence to move forward.
            </p>

            <p>
              For organisations, we connect ambition with opportunity by
              facilitating access to emerging talent, skilled professionals,
              and dependable human capital.
            </p>

            <div className="acl-about-quote">
              The future belongs to those who position themselves for it.
            </div>

            <p className="acl-about-closing">
              Explore an opportunity. Elevate your skills. Secure your next
              chapter.
            </p>

            <strong className="acl-about-destination">
              Your potential has a destination. Let's build the pathway.
            </strong>
          </div>
        </section>

        <section className="acl-visual-section">

          <div className="acl-visual-header">
            <div>
              <span>THE ACL EXPERIENCE</span>

              <h2>
                Connecting potential with opportunity.
              </h2>
            </div>

            <p>
              A platform designed to help individuals discover opportunities,
              develop professionally and build meaningful careers.
            </p>
          </div>

          <div className="acl-visual-grid">

            <div className="acl-image-card acl-image-large">
              <img
                src={image_1}
                alt="Advenware Career Link opportunities"
              />

              <div className="acl-image-overlay">
                <span>01</span>

                <div>
                  <strong>Discover Opportunities</strong>

                  <small>
                    Find pathways that match your ambitions.
                  </small>
                </div>
              </div>
            </div>

            <div className="acl-image-card">
              <img
                src={image_2}
                alt="Career development through ACL"
              />

              <div className="acl-image-overlay">
                <span>02</span>

                <div>
                  <strong>Develop Your Skills</strong>

                  <small>
                    Build practical skills for the modern workplace.
                  </small>
                </div>
              </div>
            </div>

            <div className="acl-image-card">
              <img
                src={image_3}
                alt="ACL professional connections"
              />

              <div className="acl-image-overlay">
                <span>03</span>

                <div>
                  <strong>Build Connections</strong>

                  <small>
                    Connect talent, organisations and opportunity.
                  </small>
                </div>
              </div>
            </div>

            <div className="acl-image-card acl-image-wide">
              <img
                src={image_4}
                alt="ACL career advancement"
              />

              <div className="acl-image-overlay">
                <span>04</span>

                <div>
                  <strong>Shape Your Future</strong>

                  <small>
                    Position yourself for your next chapter.
                  </small>
                </div>
              </div>
            </div>

          </div>
        </section>

        <section className="acl-services-section">

          <div className="choice-heading">

            <div>
              <span>WHAT ACL OFFERS</span>

              <h2>
                Build your path to opportunity.
              </h2>
            </div>

            <p>
              Everything you need to move forward
            </p>

          </div>

          <div className="acl-services-grid">

            <div className="acl-service-card">
              <span className="acl-service-number">01</span>
              <span className="acl-service-label">
                CANDIDATE PORTAL
              </span>

              <h3>
                Your journey towards opportunity starts here.
              </h3>

              <p>
                Create your profile, apply for placements and jobs, access
                training, and track your progress.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">02</span>
              <span className="acl-service-label">
                OPPORTUNITIES
              </span>

              <h3>
                Discover opportunities. Take your next step.
              </h3>

              <p>
                Find attachments, internships, jobs, training programmes,
                events and more.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">03</span>
              <span className="acl-service-label">
                AGENT ACCESS
              </span>

              <h3>
                Connect talent with opportunity.
              </h3>

              <p>
                Register candidates, manage referrals and support successful
                placements.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">04</span>
              <span className="acl-service-label">
                PARTNER ORGANISATIONS
              </span>

              <h3>
                Connect your organisation with the right talent.
              </h3>

              <p>
                Request students, interns, employees and skilled talent
                through ACL.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">05</span>
              <span className="acl-service-label">
                SKILLS TRAINING
              </span>

              <h3>
                Learn today. Advance tomorrow.
              </h3>

              <p>
                Build practical skills in AI, digital technology,
                communication, professionalism, entrepreneurship and
                workplace readiness.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">06</span>
              <span className="acl-service-label">
                CAREER GUIDANCE
              </span>

              <h3>
                Make informed choices. Build with direction.
              </h3>

              <p>
                Get guidance on career development, applications, interviews
                and professional growth.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">07</span>
              <span className="acl-service-label">
                CV & INTERVIEW SERVICES
              </span>

              <h3>
                Present your potential with confidence.
              </h3>

              <p>
                Get support with CVs, professional profiles, applications and
                interview preparation.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">08</span>
              <span className="acl-service-label">
                EVENTS & PROGRAMMES
              </span>

              <h3>
                Learn. Connect. Experience. Grow.
              </h3>

              <p>
                Discover career events, workshops, networking opportunities
                and development programmes.
              </p>
            </div>

            <div className="acl-service-card">
              <span className="acl-service-number">09</span>
              <span className="acl-service-label">
                SUPPORT CENTRE
              </span>

              <h3>
                We are here to help you move forward.
              </h3>

              <p>
                Get assistance with ACL services, applications, placements,
                training and enquiries.
              </p>
            </div>

          </div>
        </section>

        <section className="acl-start-section">

          <span>
            START YOUR JOURNEY
          </span>

          <h2>
            Explore an opportunity. Develop your skills. Build your
            experience. Shape your future.
          </h2>

          <p>
            ADVENWARE CAREER LINK
          </p>

          <strong>
            Empowering Talent. Building Careers. Transforming Futures.
          </strong>

        </section>

        <section className="landing-choice-section">

          <div className="choice-heading">

            <div>
              <span>GET STARTED</span>

              <h2>
                What would you like to click?
              </h2>
            </div>

            <p>
              Choose an option to continue
            </p>

          </div>

          <div className="choice-grid">

            <button
              className="choice-card account-card"
              onClick={() => handleNavigation("my_account")}
            >
              <div className="choice-number">
                01
              </div>

              <div className="choice-icon">
                <span>↗</span>
              </div>

              <div className="choice-content">

                <span className="choice-small">
                  EXISTING USER
                </span>

                <h3>
                  CANDIDATE PORTAL
                </h3>

                <p>
                  Create your profile, apply for placements and jobs, access
                  training, and track your progress.
                </p>

              </div>

              <div className="choice-arrow">
                →
              </div>
            </button>

            <button
              className="choice-card agent-card"
              onClick={() => handleNavigation("agent")}
            >
              <div className="choice-number">
                02
              </div>

              <div className="choice-icon">
                <span>◎</span>
              </div>

              <div className="choice-content">

                <span className="choice-small">
                  FIELD OPERATIONS
                </span>

                <h3>
                  AGENT ACCESS
                </h3>

                <p>
                  Register candidates, manage referrals and support successful
                  placements.
                </p>

              </div>

              <div className="choice-arrow">
                →
              </div>
            </button>

            <button
              className="choice-card employer-card"
              onClick={handleEmployerClick}
            >
              <div className="choice-number">
                03
              </div>

              <div className="choice-icon">
                <span>+</span>
              </div>

              <div className="choice-content">

                <span className="choice-small">
                  PARTNER ORGANISATIONS
                </span>

                <h3>
                  Connect your organisation with the right talent.
                </h3>

                <p>
                  Request students, interns, employees and skilled talent
                  through ACL.
                </p>

              </div>

              <div className="choice-arrow">
                →
              </div>
            </button>

            <button
              className="choice-card opportunities-card"
              onClick={() => handleNavigation("opportunities")}
            >
              <div className="choice-number">
                04
              </div>

              <div className="choice-icon">
                <span>⌕</span>
              </div>

              <div className="choice-content">

                <span className="choice-small">
                  OPPORTUNITIES
                </span>

                <h3>
                  Discover opportunities. Take your next step.
                </h3>

                <p>
                  Find attachments, internships, jobs, training programmes,
                  events and more.
                </p>

              </div>

              <div className="choice-arrow">
                →
              </div>
            </button>

          </div>
        </section>

        <section className="landing-bottom">

          <div className="bottom-stat">
            <strong>STUDENTS</strong>
            <span>Discover career opportunities</span>
          </div>

          <div className="bottom-divider"></div>

          <div className="bottom-stat">
            <strong>ORGANIZATIONS</strong>
            <span>Discover emerging talent</span>
          </div>

          <div className="bottom-divider"></div>

          <div className="bottom-stat">
            <strong>FIELD AGENTS</strong>
            <span>Build connections on the ground</span>
          </div>

        </section>

        <section
          id="contacts"
          className="acl-contacts-section"
        >
          <div className="acl-contacts-content">

            <span className="acl-contacts-label">
              CONTACTS
            </span>

            <h2>
              Let’s build the pathway together.
            </h2>

            <p>
              Have a question about opportunities, candidates, partnerships or
              ACL services? Get in touch with us.
            </p>

            <div className="acl-contact-details">

              <a
                href="mailto:advenwareholding@advenwarecareelink.com"
                className="acl-contact-item"
              >
                <div className="acl-contact-icon">
                  @
                </div>

                <div className="acl-contact-info">
                  <span>EMAIL</span>
                  <strong>
                    advenwareholding@advenwarecareelink.com
                  </strong>
                </div>

                <span className="acl-contact-arrow">
                  →
                </span>
              </a>

              <a
                href="tel:0711161754"
                className="acl-contact-item"
              >
                <div className="acl-contact-icon">
                  ☎
                </div>

                <div className="acl-contact-info">
                  <span>PHONE</span>
                  <strong>
                    0711 161 754
                  </strong>
                </div>

                <span className="acl-contact-arrow">
                  →
                </span>
              </a>

            </div>

          </div>
        </section>

      </main>

      <footer className="landing-footer">

        <span>
          © 2026 Advenware Career Link
        </span>

        <div>
          <button onClick={() => handleNavigation("opportunities")}>
            Opportunities
          </button>

          <button onClick={handleAboutClick}>
            About
          </button>

          <button onClick={handleContactsClick}>
            Support
          </button>
        </div>

        <small>
          Background photo: Ms Kabintie / Wikimedia Commons
        </small>

      </footer>

      {showServiceFee && (
        <ServiceFeeModal
          onClose={() => setShowServiceFee(false)}
        />
      )}

      {showEmployerPassword && (
        <div
          className="employer-password-overlay"
          onClick={closeEmployerPassword}
        >
          <div
            className="employer-password-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="employer-password-close"
              onClick={closeEmployerPassword}
              type="button"
            >
              ×
            </button>

            <div className="employer-password-icon">
              🔐
            </div>

            <span className="employer-password-label">
              EMPLOYER ACCESS
            </span>

            <h2>
              Enter employer password
            </h2>

            <p>
              This area is restricted to authorized employers and
              organizations.
            </p>

            <form onSubmit={handleEmployerLogin}>

              <div className="employer-password-input-wrapper">

                <input
                  type="password"
                  value={employerPassword}
                  onChange={(e) => {
                    setEmployerPassword(e.target.value);
                    setPasswordError("");
                  }}
                  placeholder="Enter password"
                  autoFocus
                />

              </div>

              {passwordError && (
                <div className="employer-password-error">
                  <span>!</span>
                  {passwordError}
                </div>
              )}

              <div className="employer-password-actions">

                <button
                  type="button"
                  className="employer-cancel-button"
                  onClick={closeEmployerPassword}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="employer-submit-button"
                >
                  Continue
                  <span>→</span>
                </button>

              </div>

            </form>

          </div>
        </div>
      )}

    </div>
  );
};

export default LandingPage;